var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"claim-account-page"},[(_vm.data)?_c('div',[_c('AuthRegisterForm',{attrs:{"dialog-state":_vm.dialogState,"claim-account-data":_vm.data,"claim-token":_vm.token}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }